import { Component, inject } from '@angular/core';

import { AuthUserService } from '@services/auth-user.service';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
  standalone: false,
})
export class ContentComponent {
  authUserService = inject(AuthUserService);
}
